import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_HEALTHCARE_PROVIDER } from "../../config/connString";
import decodedUserDetails from "utils/decodedUserDetails";
import { parsedClientDetails } from "utils/parsedClientDetails";

const createHealthcareProvider = createAsyncThunk(
  "healthcareProviders/create-healthcare-provider",
  async (data) => {
    try {
      const clientId = decodedUserDetails()?.clientId;
      const api = useAxios();
      const { isClientKedoya } = parsedClientDetails();

      const response = await api.post(URL_HEALTHCARE_PROVIDER, {
        firstName: data.firstName || null,
        licenseNumber: data.licenseNumber || null,
        licenseExpirationDate: data.licenseExpirationDate || null,
        code: isClientKedoya ? data?.code : null,
        lastName: data.lastName || null,
        title: data.title || null,
        specialty: data.specialty || null,
        phoneNumber: data.phoneNumber || null,
        email: data.email || null,
        clientId: clientId,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { createHealthcareProvider };
